import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	inviteAndAssign: {
		id: 'invite-and-assign.common.invite-and-assign',
		defaultMessage: 'Invite and assign',
		description: 'Helper text on invite and assign option',
	},
});
